if (!customElements.get("infinite-loader")) {
  class InfiniteLoader extends HTMLElement {
    constructor() {
      super();
      this.page = 1;
      this.perPage = Number(this.dataset.perPage);
      this.pages = Number(this.dataset.pages);
      this.onScrollLoadMore = this.loadMore.bind(this, { source: "scroll" });
      this.onClickLoadMore = this.loadMore.bind(this, { source: "click" });
      this.getElements();
      this.setupEventListeners();
    }
    getElements() {
      this.elements = {
        loadContainer: this.querySelector("[data-load-container]"),
        loadTrigger: this.querySelector("[data-load-trigger]"),
        pagination: this.querySelector(".sm-pagination")
      };
    }
    setupEventListeners() {
      var _a, _b;
      if (!((_a = this.elements) == null ? void 0 : _a.loadContainer) || !((_b = this.elements) == null ? void 0 : _b.loadTrigger))
        return;
      window.addEventListener("scroll", this.onScrollLoadMore);
      this.elements.loadTrigger.addEventListener("click", this.onClickLoadMore);
    }
    loadMore(context) {
      var _a;
      const isScroll = (context == null ? void 0 : context.source) === "scroll";
      if (!isScroll || ((_a = window.isElementInViewport) == null ? void 0 : _a.call(window, this.elements.loadTrigger))) {
        const { sectionId, jsonId, loading } = this.dataset;
        if (!sectionId || loading === "true" || this.page === this.pages)
          return;
        this.setAttribute("data-loading", "true");
        const search = window.location.search.slice(1);
        fetch(
          window.location.pathname + `?section_id=${sectionId}&page=${++this.page}${(search == null ? void 0 : search.length) ? "&" + search : search}`
        ).then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const loadContainer = html.querySelector("[data-load-container]");
          const quickAddModal = loadContainer.querySelectorAll("quick-add-modal");
          quickAddModal.forEach((modal, index) => {
            modal.dataset.pixelIndex = (this.page - 1) * this.perPage + (index + 1);
          });
          if (jsonId) {
            const jsonScript = document.querySelector(`#${jsonId}[type="application/json"]`);
            const newJsonScript = html.querySelector(`#${jsonId}[type="application/json"]`);
            if (jsonScript && newJsonScript) {
              const jsonProducts = [...JSON.parse(jsonScript.textContent), ...JSON.parse(newJsonScript.textContent)];
              jsonScript.textContent = JSON.stringify(jsonProducts);
            }
            const pixelListElement = this.closest("[data-pixel-list]");
            window.publish(window.PUB_SUB_EVENTS.infiniteLoadFinished, {
              accum: (this.page - 1) * this.perPage,
              data: JSON.parse(newJsonScript == null ? void 0 : newJsonScript.textContent),
              pixel: {
                listId: pixelListElement == null ? void 0 : pixelListElement.dataset.pixelListId,
                listName: pixelListElement == null ? void 0 : pixelListElement.dataset.pixelListName
              }
            });
          }
          this.elements.loadContainer.insertAdjacentHTML("beforeend", loadContainer.innerHTML);
          document.dispatchEvent(
            new CustomEvent("infiniteLoaderLoadCompleted", {
              detail: {
                source: this,
                html
              }
            })
          );
        }).catch((error) => {
          var _a2, _b;
          console.log("Error occured:", error);
          (_a2 = this.elements.loadTrigger) == null ? void 0 : _a2.classList.add("!hidden");
          (_b = this.elements.pagination) == null ? void 0 : _b.classList.remove("hidden");
          window.removeEventListener("scroll", this.onScrollLoadMore);
        }).finally(() => {
          var _a2;
          if (this.page === this.pages) {
            (_a2 = this.elements.loadTrigger) == null ? void 0 : _a2.classList.add("!hidden");
            window.removeEventListener("scroll", this.onScrollLoadMore);
          }
          this.setAttribute("data-loading", "false");
        });
      }
    }
  }
  customElements.define("infinite-loader", InfiniteLoader);
}
